/** Shared ACH routing/account validation (admin, portal, bank form). */

export const BANK_ROUTING_DIGIT_MIN = 8;
export const BANK_ROUTING_DIGIT_MAX = 12;
export const BANK_ACCOUNT_DIGIT_MIN = 8;
export const BANK_ACCOUNT_DIGIT_MAX = 17;

export function validateBankDigitField(value, { required = true, label, min, max } = {}) {
  const trimmed = String(value || '').trim();
  if (!trimmed) {
    return required ? `${label} is required.` : null;
  }
  if (!/^\d+$/.test(trimmed)) {
    return `${label} must contain numbers only.`;
  }
  if (trimmed.length < min || trimmed.length > max) {
    return `${label} must be ${min} to ${max} digits.`;
  }
  return null;
}

export function validateBankFieldValues(accountNumber, routingNumber, { required = true } = {}) {
  return (
    validateBankDigitField(accountNumber, {
      required,
      label: 'Account number',
      min: BANK_ACCOUNT_DIGIT_MIN,
      max: BANK_ACCOUNT_DIGIT_MAX,
    }) ||
    validateBankDigitField(routingNumber, {
      required,
      label: 'Routing number (ACH)',
      min: BANK_ROUTING_DIGIT_MIN,
      max: BANK_ROUTING_DIGIT_MAX,
    })
  );
}
